import React from 'react'
import NewArrivals from '../NewArrivals/NewArrivals'

const Shop = () => {

  return (
    <>
     <NewArrivals/>
    </>
  )
}

export default Shop